module.exports = __webpack_public_path__ + "static/img/background.2f2a6cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.jpg
// module id = ycj+
// module chunks = 1